// Saved Games Hook
// Manages saved/favorited games state

import { useState, useEffect } from 'react';
import { HeartGame } from '../../types/heartGames';

const SAVED_GAMES_KEY = 'heart-games-saved';

export const useSavedGames = (userId?: string) => {
  const [savedGameIds, setSavedGameIds] = useState<string[]>([]);

  useEffect(() => {
    // Load saved games from localStorage
    const saved = localStorage.getItem(SAVED_GAMES_KEY);
    if (saved) {
      try {
        setSavedGameIds(JSON.parse(saved));
      } catch (error) {
        console.error('Error loading saved games:', error);
      }
    }
  }, []);

  const isGameSaved = (gameId: string): boolean => {
    return savedGameIds.includes(gameId);
  };

  const toggleSavedGame = (gameId: string): void => {
    setSavedGameIds((prev) => {
      const newSaved = prev.includes(gameId)
        ? prev.filter((id) => id !== gameId)
        : [...prev, gameId];
      
      // Save to localStorage
      localStorage.setItem(SAVED_GAMES_KEY, JSON.stringify(newSaved));
      return newSaved;
    });
  };

  const getSavedGames = (allGames: HeartGame[]): HeartGame[] => {
    return allGames.filter((game) => savedGameIds.includes(game.id));
  };

  return {
    savedGameIds,
    isGameSaved,
    toggleSavedGame,
    getSavedGames,
  };
};

